'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('../util/validators/password-validator.js');
require('../util/helpers/strings.js');
require('../util/helpers/date.js');
require('../util/helpers/arrays.js');
require('../util/helpers/language.js');
require('../util/helpers/numbers.js');
var Vue = _interopDefault(require('vue'));
var vuePropertyDecorator = require('vue-property-decorator');
require('../util/helpers/currency.js');
var dom = require('../util/helpers/dom.js');
require('../util/helpers/debounce.js');
require('../util/helpers/throttle.js');
require('../util/helpers/functions.js');
require('../util/helpers/session.js');
require('../util/helpers/forms.js');
require('../util/helpers/keys.js');
require('../util/helpers/game.js');
require('../util/helpers/game-category.js');
require('../util/helpers/script.js');
require('../util/helpers/events.js');
require('../util/helpers/password.js');
require('../util/helpers/storage.js');
require('../util/helpers/theming.js');
require('../util/helpers/objects.js');
require('../util/helpers/slots.js');
require('../util/helpers/phone.js');
require('../util/validators/date-validator.js');
require('../util/validators/debounce-validator.js');
require('../util/types/input.js');
require('../util/types/device.enum.js');
var wrap = _interopDefault(require('@gig/web-component-wrapper'));

const CUSTOM_ELEMENT_PREFIX = "magic";
const BASE_CSS = fetch("/base.css").then((response) => response.text());
function registerComponent(component, delegatesFocus, prefix = CUSTOM_ELEMENT_PREFIX) {
  const ComponentClass = class extends vuePropertyDecorator.Mixins(component) {
  };
  const CustomComponent = wrap(Vue, ComponentClass, !!delegatesFocus, !dom.isShadyDOM() ? [BASE_CSS] : []);
  const name = `${prefix}-${component.options.name}`;
  if (!window.customElements.get(name)) {
    window.customElements.define(name, CustomComponent);
  }
  return ComponentClass;
}

exports.registerComponent = registerComponent;
